<template>
  <div
    class="base-info"
    v-if="form && form.length"
    :style="{ justifyContent: alignRight ? 'flex-end' : '' }"
  >
    <div v-for="(item, index) in form" :key="index" class="base-info-item">
      <div
        class="label"
        :style="{ width: labelWidth }"
        :class="{ 'is-edit': !item.disabled }"
      >
        {{ item.label }}
      </div>
      <el-input
        size="mini"
        :style="{ width: valueWidth }"
        v-model="item.value"
        :disabled="item.disabled"
        :type="item.type || 'text'"
        style="color: #333"
      ></el-input>
      <!-- <div
        class="value"
        :style="{ width: valueWidth }"
        :class="{ hasData: !!item.value }"
      >
        {{ item.value }}
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormItems',
  props: {
    form: {
      type: Array,
      default: () => []
    },
    labelWidth: {
      type: String,
      default: '60px'
    },
    valueWidth: {
      type: String,
      default: '120px'
    },
    alignRight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 页面数据
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
  }
}
</script>

<style scoped lang="less">
.base-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 16px;
  width: 100%;
  gap: 10px;
  margin-bottom: 10px;
  .base-info-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    color: #000;
    gap: 8px;
    .label {
      text-align: right;
      &.is-edit {
        color: #1890ff;
      }
    }
    .value {
      height: 32px;
      background-color: #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 6px;
      border: 1px solid #2a7ca7;
      &.hasData {
        background-color: #fff;
      }
    }
    ::v-deep .el-input__inner {
      color: #333 !important;
    }
  }
}
</style>
